module.exports = __webpack_public_path__ + "img/niño72.56f65d46.jpg";